import { inject, Injectable } from '@angular/core';

import { SSR_DEV_MODE, RESPONSE } from './express.tokens';

@Injectable({
  providedIn: 'root'
})
export class ServerTimingService {
  private readonly response = inject(RESPONSE, { optional: true });
  private readonly devMode = inject(SSR_DEV_MODE, { optional: true });

  start(name: string, desc: string): void {
    if(!this.devMode) {
      return;
    }

    this.response?.startTime(name, desc);
  }

  end(name: string): void {
    if(!this.devMode) {
      return;
    }

    this.response?.endTime(name);
  }
}